$(document).ready(function() {


 $.validator.addMethod("indianPhone", function(value, element) {
    return this.optional(element) || /^(?:\+91)?[6-9]\d{9}$/.test(value);
  }, "Please enter a valid phone number");

  
  // Form validation
  var validator = $("#consultancyForm").validate({
    errorElement: "span",
    errorClass: "error",
    errorPlacement: function(error, element) {
      if (element.attr('name') === 'options[]') {
         $('#checkbox-error').show();
      } else if(element.attr('name') === 'products[]'){
         $('#products-error').show();
      } else{ 
        error.insertBefore(element);
      }
    },
    rules: {
      name: "required",
      // email: {
      //   required: true,
      //   email: true
      // },
      phone: {
       required: true,
       indianPhone: true
      },
      'purpose_consultation[]': {
        required: true
      },
      'products_looking[]': {
        required: true
      },
      'preferred_design[]': {
        required: true
      },
      'bedsheet[]': {
        required: true
      },
      'carpet[]': {
        required: true
      },
      'dinnerware[]': {
        required: true
      },
      'acBlanket[]': {
        required: true
      },
      'tableLinen[]': {
        required: true
      },
      'towelsNapkins[]': {
        required: true
      },
      message: "required"
    }
  });


  // document.getElementById("consultancyForm").addEventListener("submit", async (e) => {
  //   e.preventDefault();
  
  //   if (validator.form()) {

  //   // for step 3
  //   const productPreferences = {};
  //   const step3Checkboxes = document.querySelectorAll('#step3 input[type="checkbox"]:checked');
  //   step3Checkboxes.forEach(checkbox => {
  //     const category = checkbox.name.replace('[]', '');
  //     if (!productPreferences[category]) {
  //       productPreferences[category] = [];
  //     }
  //     productPreferences[category].push(checkbox.value);
  //   });


  //    const formData = {
  //         name: e.target.name.value,
  //         phone: e.target.phone.value,
  //         email: e.target.email.value,
  //        // message: e.target.message.value,
  //         rooms: Array.from(e.target.querySelectorAll('input[name="options[]"]:checked')).map(cb => cb.value),
  //         products: Array.from(e.target.querySelectorAll('input[name="products[]"]:checked')).map(cb => cb.value),
  //          preferences: productPreferences,
  //         consultation_datetime: e.target.consultation_datetime.value,
  //         problem_description: e.target.problem_description.value,
  //       };

  //       const fileData = new FormData();
  //       Array.from(e.target.reference_photos.files).forEach((file, index) => {
  //         fileData.append(`file${index}`, file);
  //       });

      
  //       // Send data to your Google Apps Script Web App URL
  //       const response = await fetch("https://script.google.com/macros/s/AKfycbxk9JrQ74LyDNUM28bzEGWw2GH54R5-uGIjtZdFq5HJa5H21awuSc540g_sDdtQp_ff/exec", {
  //         method: "POST",
  //         body: JSON.stringify(formData)
  //       });
    
  //       if (response.ok) alert("Data saved!");
  //   }
  // });


  

document.getElementById("consultancyForm").addEventListener("submit", async (e) => {
  e.preventDefault();

  if (validator.form()) {

     const loader = document.getElementById("loader");
    loader.style.display = "block";

    
    try {
      // Collect form data
      const productPreferences = {};
      document.querySelectorAll('#step3 input[type="checkbox"]:checked').forEach(checkbox => {
        const category = checkbox.name.replace('[]', '');
        productPreferences[category] = productPreferences[category] || [];
        productPreferences[category].push(checkbox.value);
      });


    // Get the file input element and its files.
      const fileInput = e.target.reference_photos;
      const files = fileInput.files;
      let filePromises = [];

      // Convert each file to a base64 string.
      for (let i = 0; i < files.length; i++) {
        filePromises.push(new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = function(event) {
            // Remove the "data:*/*;base64," part from the result
            const base64Data = event.target.result.split(',')[1];
            resolve({
              fileName: files[i].name,
              mimeType: files[i].type,
              data: base64Data
            });
          };
          reader.onerror = reject;
          reader.readAsDataURL(files[i]);
        }));
      }

      // Wait for all files to be processed
      const uploadedFiles = await Promise.all(filePromises);


      const date = e.target.dateandtime.value;   
       const time = e.target.timedata.value;     
       const consultation_datetime = `${date} ${time}`;
      //   const consultation_datetime = `${date}`;
      
      const formData = {
        name: e.target.name.value,
        phone: e.target.phone.value,
        email: e.target.email.value,
        // rooms: Array.from(e.target.querySelectorAll('input[name="options[]"]:checked')).map(cb => cb.value),
        // products: Array.from(e.target.querySelectorAll('input[name="products[]"]:checked')).map(cb => cb.value),

        purpose_consultation: Array.from(e.target.querySelectorAll('input[name="purpose_consultation[]"]:checked')).map(cb => cb.value),
        products_looking: Array.from(e.target.querySelectorAll('input[name="products_looking[]"]:checked')).map(cb => cb.value),
        preferred_design: Array.from(e.target.querySelectorAll('input[name="preferred_design[]"]:checked')).map(cb => cb.value),
       
        // preferences: productPreferences,
        consultation_datetime,
        problem_description: e.target.requirements.value,
        reference_photos: uploadedFiles 
      };
      
      const response = await fetch("https://script.google.com/macros/s/AKfycbx-vYHpccZ2HsKyWm3UlFQWJ73Q5s7tVSA-nFBeQ7vjTztNGcBxHXagKQZzg5xs-Cm_1A/exec", {
        method: "POST",
        body: JSON.stringify(formData)
      });

       loader.style.display = "none";
      
      if (response.ok) {

         // const popup = document.getElementById("successPopup");
         // popup.style.display = "block";
         
        window.location.href = '/products/design-counsultation';

          // fetch('/cart/add.js', {
          // method: 'POST',
          // headers: {
          //     'Content-Type': 'application/json',
          // },
          // body: JSON.stringify({
          //     quantity: 1,
          //     id: 45946719502577
          // })
          // })
          // .then(response => response.json())
          // .then(data => {
          //    // alert("added");
          //    // window.location.href = '/checkout';
          // loader.style.display = "none";
          //    // document.querySelector('[name="checkout"]').click();
          //    // $('[name="checkout"]').trigger("click");
            
          // })
          // .catch(error => console.error('Error:', error));
        
      }
    } catch (error) {
       loader.style.display = "none";
      console.error('Submission error:', error);
      alert("Submission failed. Please try again.");
    }
  }
});

  
// jQuery.validator.addMethod("pattern", function(value, element, param) {
//   return this.optional(element) || param.test(value);
// }, "Invalid Number");

  
document.querySelectorAll('.popoverl, #closePopup').forEach(function(element) {
  element.addEventListener('click', function() {
    document.getElementById('successPopup').style.display = 'none';
  });
});

  
function showStep4() {
   $(".product-option-group").hide();

  const selectedProducts = Array.from(document.querySelectorAll('input[name="products[]"]:checked'))
    .map(cb => cb.value);

  selectedProducts.forEach(product => {
     document.querySelector(`[data-product="${product}"]`).style.display = "block";
  });
  
}

flatpickr("#datetimePicker", {
  enableTime: true,
  dateFormat: "Y-m-d H:i",
  minDate: "today", // Prevent selecting past dates
  // Disable weekends (Saturday=6 and Sunday=0)
  disable: [
    function(date) {
      return (date.getDay() === 0 || date.getDay() === 6);
    }
  ],
  // Use 12-hour format (change to true for 24-hour format)
  time_24hr: false,
  minuteIncrement: 30,
  minTime: "15:00",
  maxTime: "18:00",
});

flatpickr("#newdate", {
  dateFormat: "d/m/Y", // Show as DD/MM/YYYY
  minDate: new Date().fp_incr(2), // Set minDate to tomorrow
  disable: [
    function(date) {
      // Disable weekends (Saturday=6 and Sunday=0)
      return (date.getDay() === 0 || date.getDay() === 6);
    }
  ]
});

  
// flatpickr("#newdate", {
//   dateFormat: "d/m/Y", // Only show the date (year-month-day format)
//   minDate: "today", // Prevent selecting past dates
//   disable: [
//     function(date) {
//       return (date.getDay() === 0 || date.getDay() === 6); // Disable weekends (Saturday=6 and Sunday=0)
//     }
//   ],
// });

// flatpickr("#newtime", {
//   enableTime: true,
//   noCalendar: true,
//   dateFormat: "h:i K", // Format: hours:minutes AM/PM
//   time_24hr: false,    // Disable 24hr mode
//   minuteIncrement: 30,
//   minTime: "10:30",
//   maxTime: "18:30",
// });


flatpickr("#newtime", {
  enableTime: false,
  noCalendar: true,
  dateFormat: "h:i K",  // display format (12hr with AM/PM)
  time_24hr: false,
  minuteIncrement: 30,
  maxTime: "18:30",
  onOpen: function(selectedDates, dateStr, instance) {
    instance.set("minTime", getDynamicMinTime());
  }
});

// Helper function to determine the minimum selectable time
function getDynamicMinTime() {
  const dateInput = document.getElementById("newdate").value;

  if (!dateInput) {
    return "10:30";
  }
  
  // Parse the date; assuming format "DD/MM/YYYY"
  const parts = dateInput.split("/");
  if (parts.length !== 3) return "10:30";
  
  // Create a date object from selected date (note: month is zero-based)
  const selectedDate = new Date(parts[2], parts[1] - 1, parts[0]);
  const today = new Date();
  
  // Check if the selected date is today
  if (selectedDate.toDateString() === today.toDateString()) {
    // Allowed start and end times
    const startHour = 10, startMinute = 30;
    const maxHour = 18, maxMinute = 30;
    
    const now = new Date();
    // If current time is before the allowed start, use "10:30"
    if (now.getHours() < startHour || (now.getHours() === startHour && now.getMinutes() < startMinute)) {
      return "10:30";
    }
    
    if (now.getHours() > maxHour || (now.getHours() === maxHour && now.getMinutes() >= maxMinute)) {
      return "18:30";
    }
    
    let hour = now.getHours();
    let minute = now.getMinutes();
    if (minute < 30) {
      minute = 30;
    } else {
      hour = hour + 1;
      minute = 0;
    }
    
    // Ensure we don't go below start time
    if (hour < startHour || (hour === startHour && minute < startMinute)) {
      return "10:30";
    }
    // Ensure we don't exceed max time
    if (hour > maxHour || (hour === maxHour && minute > maxMinute)) {
      return "18:30";
    }
    
    // Return the time formatted as "HH:MM"
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  } else {
    // For dates other than today, use the default start time
    return "10:30";
  }
}


  
  
$(".next-btn1").click(function() {
   if (validator.form()) {
      $(".tab-pane").hide();
      $("#step2").fadeIn(1000);

      $("html, body").animate({ scrollTop: 0 }, 600);
     
    }
});
  
$(".pre-btn2").click(function() {
      $(".tab-pane").hide();
      $("#step1").fadeIn(1000);

     $("html, body").animate({ scrollTop: 0 }, 600);
});

$(".next-btn2").click(function() {
   if (validator.form()) {
      $(".tab-pane").hide();
       showStep4();
      $("#step3").fadeIn(1000);

     $("html, body").animate({ scrollTop: 0 }, 600);
     
    }
});

$(".pre-btn3").click(function() {
      $(".tab-pane").hide();
      $("#step2").fadeIn(1000);
    $("html, body").animate({ scrollTop: 0 }, 600);
});

$(".next-btn3").click(function() {
   if (validator.form()) {
      $(".tab-pane").hide();
      $("#step4").fadeIn(1000);
      $("html, body").animate({ scrollTop: 0 }, 600);
    }
});

$(".pre-btn4").click(function() {
      $(".tab-pane").hide();
      $("#step3").fadeIn(1000);
     $("html, body").animate({ scrollTop: 0 }, 600);
});


$(".next-btn4").click(function() {
   if (validator.form()) {
      
     var consultationDateTime = $("#datetimePicker").val();
    
    var isoStr = consultationDateTime.replace(" ", "T") + ":00";
    
    var appointmentStart = new Date(isoStr);
    var appointmentEnd = new Date(appointmentStart.getTime() + 30 * 60000);
    
    var endpoint = "https://script.google.com/macros/s/AKfycbycUkJTp9_7sNxp2Ssk3A-Fd6cQ6KqC-8oq16OWhKPrPBmNrSJfLaDBqWyA3oQTxuTp/exec";
    var url = endpoint + "?start=" + encodeURIComponent(appointmentStart.toISOString()) +
              "&end=" + encodeURIComponent(appointmentEnd.toISOString());
    
    $("#loader").show();
    
    $.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      success: function(response) {
        $("#loader").hide();
        if (response.available) {
          // Slot is available. Move to step5.
          $(".tab-pane").hide();
          $("#step5").fadeIn(1000);
          $("html, body").animate({ scrollTop: 0 }, 600);
        } else {
          alert(response.message);
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        $("#loader").hide();
        alert("Error checking slot availability: " + textStatus);
      }
    });
     

     
      // $(".tab-pane").hide();
      // $("#step5").fadeIn(1000);
      // $("html, body").animate({ scrollTop: 0 }, 600);
    }
});

$(".pre-btn5").click(function() {
      $(".tab-pane").hide();
      $("#step4").fadeIn(1000);
    $("html, body").animate({ scrollTop: 0 }, 600);
});




let selectedFiles = new DataTransfer();


const fileInput = document.getElementById('photoUpload');
const previewContainer = document.getElementById('previewContainer');


fileInput.addEventListener('change', function(e) {
  // Reset the DataTransfer object and clear previous previews
  selectedFiles = new DataTransfer();
  previewContainer.innerHTML = '';

  // Add each selected file to the DataTransfer object and display its preview
  Array.from(fileInput.files).forEach((file, index) => {
    selectedFiles.items.add(file);
    displayPreview(file, index);
  });

  fileInput.files = selectedFiles.files;
});

function displayPreview(file, index) {
  const reader = new FileReader();
  reader.onload = function(e) {
    // Create a container for the image and remove button
    const wrapper = document.createElement('div');
    wrapper.style.display = "inline-block";
    wrapper.style.margin = "10px";
    wrapper.style.textAlign = "center";

    // Create the image element
    const img = document.createElement('img');
    img.src = e.target.result;
    img.style.width = "100px";
    img.style.height = "100px";
    img.style.objectFit = "cover";
    img.style.display = "block";
    img.style.marginBottom = "5px";

    const removeBtn = document.createElement('button');
    removeBtn.type = "button";
    removeBtn.textContent = "Remove";
    removeBtn.style.fontSize = "0.8em";
    removeBtn.addEventListener('click', function() {
      removeFile(index);
    });

    // Append the image and button to the wrapper, then to the container
    wrapper.appendChild(img);
    wrapper.appendChild(removeBtn);
    previewContainer.appendChild(wrapper);
  };
  reader.readAsDataURL(file);
}

function removeFile(index) {
 
  const fileArray = Array.from(selectedFiles.files);
  fileArray.splice(index, 1);

  selectedFiles = new DataTransfer();
  fileArray.forEach(file => selectedFiles.items.add(file));

  fileInput.files = selectedFiles.files;

  // Re-display the previews
  previewContainer.innerHTML = '';
  Array.from(selectedFiles.files).forEach((file, i) => {
    displayPreview(file, i);
  });
}


  
  
});

    

  
